<script>
import options from "./CheckoutStepTwo.options";
export default options;
</script>

<template>
  <article
    class="kb-checkout-step-two"
    aria-live="polite"
    :class="{ 'kb-checkout-step-one--submitting': isSubmitting }"
  >
    <section class="kb-checkout-step-two__delivery-card-wrapper">
      <DeliveryCard
        type="home"
        svgIcon='<svg role="presentation" alt="" width="20" height="20" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="m19.796 9.07-4.333-3.333V2.03H12.56v1.482L10 1.535.205 9.07l1.712 2.223 1.34-1.025v7.209a1.028 1.028 0 0 0 1.025 1.025h4.137v-8.14H11.8v8.14h3.403v-.697h-2.705v-8.14H7.721v8.14H4.275a.328.328 0 0 1-.321-.324v-7.75L10 5.078l6.077 4.67v8.758h.698v-8.223l1.31 1.01 1.71-2.224Zm-6.54-6.342h1.5v2.474l-1.5-1.162V2.728ZM10 4.186l-7.958 6.128-.858-1.116L10 2.416l4.765 3.665v.024h.028l4.024 3.093-.858 1.116L10 4.186Z" fill="#810010"/></svg>'
      />
      <DeliveryCard
        type="pickUp"
        svgIcon='<svg role="presentation" alt="" width="20" height="20" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M4.688 7.5a5.313 5.313 0 0 1 10.625 0c0 2.428-1.39 5.126-2.803 7.234l-1.074-.797-.372.501 1.595 1.185.184-.267c1.482-2.155 3.095-5.119 3.095-7.856a5.937 5.937 0 1 0-11.876 0c0 2.599 1.454 5.4 2.865 7.517a31.478 31.478 0 0 0 2.598 3.364 18.856 18.856 0 0 0 .23.253l.013.013.004.004.001.001.227.24.229-.242.005-.005.018-.02a17.008 17.008 0 0 0 .335-.37c.224-.255.54-.625.907-1.083l-.488-.39A29.331 29.331 0 0 1 10 17.973l-.009-.01a30.836 30.836 0 0 1-2.544-3.294c-1.4-2.1-2.76-4.769-2.76-7.17ZM10 18.438l-.227.214.227-.215Z" fill="#810010"/><path fill-rule="evenodd" clip-rule="evenodd" d="M10 3.438a4.062 4.062 0 1 0 0 8.124 4.062 4.062 0 0 0 0-8.124ZM6.562 7.5a3.437 3.437 0 1 1 6.875 0 3.437 3.437 0 0 1-6.874 0Z" fill="#810010"/></svg>'
      />
    </section>

    <template v-if="showDifferentAddress && !showPickUpAddresses">
      <DeliveryAddress :isStepSubmitting="isStepSubmitting" />
    </template>


    
    <template v-if="showPickUpAddresses">
      <slot name="pickupAddressMessage"></slot>

      <PickUpAddress :displayInputErrors="displayInputErrors" />
    </template>

    <!-- same styles as step one so css class reused -->
    <div class="kb-checkout-step-one__navigation">
      <div class="kb-checkout-step-one__navigation-breaker">
        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 704 1" aria-hidden="true" role="presentation">
          <path fill="#DFDFDB" d="M0 0h704v1H0z" />
        </svg>
      </div>
      <div class="kb-checkout-step-one__navigation-button-wrapper">
        <button @click="toStepOne" class="kb-button">{{
          getLabel("backButtonTextStep2")
        }}</button>
        <button
          @click="onSubmit"
          :disabled="isSubmitting || isStepSubmitting"
          class="kb-checkout-step-one__bottom-button submit kb-button kb-button--full-color-spot"
        >
          {{ getLabel("submitButtonTextStep2") }}
        </button>
      </div>
    </div>

    <template v-if="isSubmitting">
      <div class="kb-spinner-overlay">
        <div
          class="kb-spinner-overlay__spinner kb-spinner-overlay__spinner--sticky"
        ></div>
      </div>
    </template>
  </article>
</template>
